<template>
  <div>
    <ConfigListItem
      label="Uso da serial"
      :value="strValue"
      :date="row && row.updatedAt"
      :login="row && row.updatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Uso da Serial" @close="dismiss" />

        <v-card-text v-if="readonly" class="pa-6">
          <p>
            O valor da configuração "Uso da Serial" está 0x03 ou 0x04, o que
            impede a alteração desta configuração.
          </p>
          <p>
            Entre em contato com o time de desenvolvimento para corrigir.
          </p>
        </v-card-text>

        <v-card-text v-else class="pa-6">
          <v-list class="py-0">
            <v-list-item
              class="px-6 rounded-lg"
              v-for="opt in opts"
              :class="{ 'oderon lighten-1': opt.value == clonedValue }"
              :key="opt.value"
              @click="clonedValue = opt.value"
            >
              <v-list-item-title class="d-flex align-center">
                <OCheckIcon
                  class="mr-4"
                  radio
                  :value="opt.value == clonedValue"
                />
                {{ opt.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { getCfg } from './config-utils.js'
import ConfigListItem from './ConfigListItem.vue'
import VehicleCfgs from 'vehicle-cfgs'
import TheUser from 'oderon-vue/auth/TheUser'

export default {
  components: { ConfigListItem },
  props: {
    configDef: { required: true },
    allConfigs: { required: true }
  },
  data() {
    return {
      opts: VehicleCfgs.get(`uso-da-serial`, 'opts'),
      clonedValue: null,
      TheUser
    }
  },
  computed: {
    readonly() {
      if (
        this.TheUser &&
        this.TheUser.user &&
        this.TheUser.user.profile &&
        this.TheUser.user.profile.permissions &&
        this.TheUser.user.profile.permissions.canEditUsoDaSerial
      )
        return false

      let x = getCfg(this.allConfigs, 'uso-da-serial')
      return x == '0x03' || x == '0x04'
    },
    row() {
      return this.allConfigs.find((x) => x.key == 'uso-da-serial')
    },
    strValue() {
      let optValue = this.row && this.row.value
      let opt = this.opts.find((x) => x.value == optValue)
      if (opt == null) return '??'
      else return opt.label
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValue = this.row && this.row.value
      return this.$refs.dialog.$open()
    },
    async save() {
      const payload = { [this.configDef.code]: this.clonedValue }
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style lang="sass"></style>
